import { useEffect, type FC } from "react";
import { useLocation } from "react-router-dom";
import type { TitleProps } from "./TitleProps";

const titles: Record<string, string> = {
  "/": "Lunamalies | Lunar Anomaly Archive",
  "/catalog": "Catalog | Lunamalies",
  "/about": "About | Lunamalies",
  "/contact": "Contact | Lunamalies",
};

const Title: FC<TitleProps> = ({ title }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
      return;
    }

    document.title =
      titles[location.pathname] ?? "Lunamalies | Lunar Anomaly Archive";
  }, [location, title]);

  return null;
};

export default Title;
